import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { App } from './App'
import { unregister } from './registerServiceWorker';
import store from './store/configureStore'
import ErrorBoundary from './componentes/ErrorBoundary'
import './interceptors/requestResponseLoadingInterceptors'
import './interceptors/responseErrorInterceptors';
import './interceptors/axiosResquestInterceptor'

import jwtInterceptor from './interceptors/authenticationJwtInterceptors'
import { recuperarAmbiente } from './util/ambienteActions';

store.dispatch(recuperarAmbiente());

jwtInterceptor(store);

export default ReactDOM.render(
  <ErrorBoundary>
    <Provider store={store}>
      <App/>
    </Provider>
  </ErrorBoundary>,
  document.getElementById('root')
)

unregister();
